import React from "react";

export default function MapPopUp({ feature, position, onClose }) {
  if (!feature || !position) return null;

  const left = typeof position.left === "number" ? position.left : 100;
  const top = typeof position.top === "number" ? position.top : 100;

  const keys = Object.keys(feature);
  if (keys.length === 0 || feature.erreur) {
    return (
      <div
        style={{
          position: "absolute",
          left,
          top,
          background: "#e0f7ea",
          border: "2px solid #16a34a",
          borderRadius: "8px",
          padding: "1em",
          zIndex: 1000,
          minWidth: "220px",
          boxShadow: "0 2px 8px #232b2180",
          color: "#16a34a"
        }}
      >
        <button
          style={{
            float: "right",
            background: "none",
            border: "none",
            fontWeight: "bold",
            fontSize: "1.2em",
            cursor: "pointer"
          }}
          onClick={onClose}
          title="Fermer"
        >
          ×
        </button>
        <div>{feature.erreur ? feature.erreur : "Aucune information attributaire"}</div>
      </div>
    );
  }

  return (
    <div
      style={{
        position: "absolute",
        left,
        top,
        background: "#fff",
        border: "1px solid #232b21",
        borderRadius: "8px",
        padding: "1em",
        zIndex: 1000,
        minWidth: "220px",
        boxShadow: "0 2px 8px #232b2180"
      }}
    >
      <button
        style={{
          float: "right",
          background: "none",
          border: "none",
          fontWeight: "bold",
          fontSize: "1.2em",
          cursor: "pointer"
        }}
        onClick={onClose}
        title="Fermer"
      >
        ×
      </button>
      <div>
        {Object.entries(feature).map(([key, value]) => (
          <div key={key} style={{ marginBottom: "0.3em" }}>
            <strong style={{ color: "#16a34a" }}>{key}:</strong>{" "}
            <span style={{ color: "#000" }}>{value !== null ? value.toString() : ""}</span>
          </div>
        ))}
      </div>
    </div>
  );
}